export default {"src":"/_next/static/media/enerflo-platform-icon-single-login.d647c1d5.svg","height":160,"width":160};